import { OnInit, EventEmitter, ElementRef } from '@angular/core';
import { FormBuilder, FormGroup, ControlValueAccessor } from '@angular/forms';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
var MultipleValuesInputComponent = /** @class */ (function () {
    function MultipleValuesInputComponent(formBuilder, el) {
        this.formBuilder = formBuilder;
        this.el = el;
        this.name = '';
        this.formSubmitted = new EventEmitter();
        this.displayedColumns = ['name', 'actions'];
        this.values = [];
        this.dataSource = new MatTableDataSource(this.values);
        this.disabled = false;
    }
    Object.defineProperty(MultipleValuesInputComponent.prototype, "paginatorContent", {
        set: function (paginator) {
            this.dataSource.paginator = paginator;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MultipleValuesInputComponent.prototype, "inputValues", {
        set: function (values) {
            this.values = values || [];
            if (this.values.length > 0) {
                this.dataSource.data = this.values;
                // this.formSubmitted.emit(this.values);
            }
            else {
                this.dataSource.data = [];
            }
        },
        enumerable: true,
        configurable: true
    });
    MultipleValuesInputComponent.prototype.ngOnInit = function () {
        this.form = this.formBuilder.group({
            value: []
        });
    };
    MultipleValuesInputComponent.prototype.changeValueInput = function (value) {
        if (!value) {
            this.formSubmitted.emit(this.values);
        }
    };
    MultipleValuesInputComponent.prototype.addNewRecord = function () {
        var _this = this;
        var duplicate = this.values.filter(function (existingValue) { return existingValue === _this.form.get('value').value; });
        if (!duplicate.length) {
            this.values.unshift(this.form.get('value').value);
            this.form.get('value').setValue('');
            this.dataSource.data = this.values;
            this.formSubmitted.emit(this.values);
        }
    };
    MultipleValuesInputComponent.prototype.editValue = function (value) {
        this.formSubmitted.emit(this.values);
        var inputElement = this.el.nativeElement.children[0][0];
        inputElement.focus();
        this.form.get('value').setValue(value);
        this.values = this.values.filter(function (existingValue) { return existingValue !== value; });
        this.dataSource.data = this.values;
    };
    MultipleValuesInputComponent.prototype.deleteValue = function (value) {
        this.values = this.values.filter(function (existingValue) { return existingValue !== value; });
        this.dataSource.data = this.values;
        this.formSubmitted.emit(this.values);
    };
    MultipleValuesInputComponent.prototype.writeValue = function (obj) {
        this.values = obj || [];
        this.dataSource.data = this.values || [];
        if (this.onChange) {
            this.onChange(obj || []);
        }
    };
    MultipleValuesInputComponent.prototype.registerOnChange = function (fn) {
        this.onChange = fn;
    };
    MultipleValuesInputComponent.prototype.registerOnTouched = function (fn) {
        this.onTouched = fn;
    };
    MultipleValuesInputComponent.prototype.setDisabledState = function (isDisabled) {
        this.disabled = isDisabled;
    };
    return MultipleValuesInputComponent;
}());
export { MultipleValuesInputComponent };
